import { Component } from "react";
import React from "react";
import "./Contact.css";
import {
  Box,
  Typography,
  Grid,
  Button,
  Container,
  TextField,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  Card,
  Chip,
} from "@mui/material";
import Navbar from "../../Home/Components/Nav";
import Footer from "../../Home/Components/Footer";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import BuildIcon from "@mui/icons-material/Build";
import Checkbox from "@mui/material/Checkbox";

// ─── Location Data ───────────────────────────────────────────────────────────
const LOCATIONS = {
  showroomBhubaneswar: {
    name: "Central MG Bhubaneswar",
    address: "Plot. No - 29/2094 Dumuduma, Khandagiri, Bhubaneswar, Odisha 751030",
    phone: "8599005857",
    email: "bhubaneshwarcentral.marketing1@mgdealer.co.in",
    whatsapp: "8599005857",
    lat: 20.254779,
    lng: 85.786907,
    type: "Showroom",
  },
  serviceBhubaneswar: {
    name: "MG Workshop – Bhubaneswar",
    address: "M/S Super Sales Automobiles (P) Ltd, (MG Workshop), Plot No 2122, 2200 Near SR Valley, Puri Bypass Road, Bhubaneswar, Odisha 751018",
    phone: "9124569097",
    email: "bhubaneshwarcentral.servicemanager@mgdealer.co.in",
    whatsapp: "9124569097",
    lat: 20.258421,
    lng: 85.867146,
    type: "Service",
  },
  showroomCuttack: {
    name: "MG Central – Cuttack",
    address: "M/s Super Sales Automobiles Pvt Ltd (MG Showroom), Plot No 11-1B/10, CDA Sector-11, Markatnagar, Cuttack, Odisha 753015",
    phone: "8599005857",
    email: "bhubaneshwarcentral.marketing1@mgdealer.co.in",
    whatsapp: "8599005857",
    lat: 20.48048,
    lng: 85.821516,
    type: "Showroom",
  },
  showroomBerhampur: {
    name: "MG Central – Berhampur",
    address: "Super Sales Berhampur, Plot No 857/1225, Chhatrapur, NH 16, Sindurapalli, Ganjam - 761020",
    phone: "9124568338",
    email: "bhubaneshwarcentral.marketing1@mgdealer.co.in",
    whatsapp: "9124568338",
    lat: 19.367333,
    lng: 84.946667,
    type: "Showroom",
  },
  serviceBerhampur: {
    name: "MG Central Service – Berhampur",
    address: "Super Sales Berhampur, Plot No 857/1225, Chhatrapur, NH 16, Sindurapalli, Ganjam - 761020",
    phone: "9124569097",
    email: "bhubaneshwarcentral.servicemanager@mgdealer.co.in",
    whatsapp: "9124569097",
    lat: 19.367333,
    lng: 84.946667,
    type: "Service",
  },
  showroomJajpur: {
    name: "MG Central – Jajpur",
    address: "MG Jajpur, Plot No 226, Patharapada, Byasanagar, Panikoili, Jajpur - 755043",
    phone: "9124568338",
    email: "bhubaneshwarcentral.marketing1@mgdealer.co.in",
    whatsapp: "9124568338",
    mapsUrl: "https://maps.app.goo.gl/4BPTmCQLjPYwNiGy6",
    type: "Showroom",
  },
  serviceJajpur: {
    name: "MG Central Service – Jajpur",
    address: "MG Jajpur, Plot No 226, Patharapada, Byasanagar, Panikoili, Jajpur - 755043",
    phone: "9124568338",
    email: "bhubaneshwarcentral.marketing1@mgdealer.co.in",
    whatsapp: "9124568338",
    mapsUrl: "https://maps.app.goo.gl/4BPTmCQLjPYwNiGy6",
    type: "Service",
  },
};

const openDirection = ({ lat, lng, mapsUrl }) => {
  const url = mapsUrl
    ? mapsUrl
    : `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  window.open(url, "_blank");
};

const openWhatsApp = (number) => {
  window.open(`https://wa.me/91${number}`, "_blank");
};

// ─── Location Card ────────────────────────────────────────────────────────────
const LocationCard = ({ location }) => {
  const isService = location.type === "Service";
  return (
    <Card
      elevation={0}
      sx={{
        border: "1.5px solid #eee",
        borderRadius: "20px",
        p: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: "0 12px 36px rgba(209,34,48,0.12)",
          borderColor: "#D12230",
          transform: "translateY(-4px)",
        },
      }}
    >
      {/* Type badge */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Chip
          icon={
            isService
              ? <BuildIcon sx={{ fontSize: "14px !important", color: isService ? "#1565c0 !important" : "#D12230 !important" }} />
              : <DirectionsCarIcon sx={{ fontSize: "14px !important", color: "#D12230 !important" }} />
          }
          label={location.type}
          size="small"
          sx={{
            backgroundColor: isService ? "#e3f0ff" : "#fff0f0",
            color: isService ? "#1565c0" : "#D12230",
            fontWeight: "bold",
            fontSize: "11px",
          }}
        />
      </Box>

      {/* Name */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          fontFamily: "Roboto, sans-serif",
          color: "#1a1a1a",
          fontSize: "16px",
          lineHeight: 1.3,
        }}
      >
        {location.name}
      </Typography>

      {/* Address */}
      <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
        <LocationOnIcon sx={{ color: "#D12230", fontSize: 18, mt: 0.2, flexShrink: 0 }} />
        <Typography
          variant="body2"
          sx={{ color: "#555", fontFamily: "Roboto, sans-serif", lineHeight: 1.6, fontSize: "13px" }}
        >
          {location.address}
        </Typography>
      </Box>

      {/* Phone */}
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <LocalPhoneIcon sx={{ color: "#D12230", fontSize: 16, flexShrink: 0 }} />
        <Typography
          component="a"
          href={`tel:${location.phone}`}
          sx={{
            color: "#333",
            fontSize: "13px",
            textDecoration: "none",
            fontFamily: "Roboto, sans-serif",
            "&:hover": { color: "#D12230" },
          }}
        >
          {location.phone}
        </Typography>
      </Box>

      {/* Email */}
      <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
        <EmailIcon sx={{ color: "#D12230", fontSize: 16, mt: 0.2, flexShrink: 0 }} />
        <Typography
          component="a"
          href={`mailto:${location.email}`}
          sx={{
            color: "#333",
            fontSize: "12px",
            textDecoration: "none",
            wordBreak: "break-word",
            fontFamily: "Roboto, sans-serif",
            "&:hover": { color: "#D12230" },
          }}
        >
          {location.email}
        </Typography>
      </Box>

      {/* Action Buttons */}
      <Box sx={{ display: "flex", gap: 1, mt: "auto", pt: 1 }}>
        <Button
          variant="contained"
          size="small"
          onClick={() => openDirection(location)}
          startIcon={<LocationOnIcon />}
          sx={{
            flex: 1,
            backgroundColor: "#D12230",
            borderRadius: "8px",
            fontWeight: "bold",
            fontSize: "11px",
            py: 1,
            "&:hover": { backgroundColor: "#a81a27" },
          }}
        >
          Directions
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={() => openWhatsApp(location.whatsapp)}
          startIcon={<WhatsAppIcon />}
          sx={{
            flex: 1,
            borderColor: "#25D366",
            color: "#25D366",
            borderRadius: "8px",
            fontWeight: "bold",
            fontSize: "11px",
            py: 1,
            "&:hover": { backgroundColor: "#f0fff5", borderColor: "#25D366" },
          }}
        >
          WhatsApp
        </Button>
      </Box>
    </Card>
  );
};

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      querySubject: "",
      queryType: "",
      query: "",
      agreedToPolicy: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { firstName, lastName, mobile, email, queryType, querySubject, query, agreedToPolicy } = this.state;
    this.props.AddContactForm(firstName, lastName, mobile, email, queryType, querySubject, query, agreedToPolicy);
    this.setState({
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      queryType: "",
      querySubject: "",
      query: "",
      agreedToPolicy: false,
    });
  };

  render() {
    return (
      <div id="container">
        <Navbar />

        {/* Banner */}
        <div id="banner-image-contact">
          <div id="write">
            <Typography
              variant="h4"
              sx={{
                color: "white",
                fontFamily: "Roboto, sans-serif",
                fontWeight: "bold",
                textAlign: "center",
                fontSize: { md: "38px", xs: "20px", sm: "28px" },
                letterSpacing: "2px",
                px: 2,
              }}
            >
              HAVE A QUERY? CONNECT WITH US
            </Typography>
          </div>
        </div>

        {/* Quick Info Strip */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #D12230 0%, #8B0000 100%)",
            py: 3,
            px: { xs: 2, md: 6 },
          }}
        >
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            {[
              { icon: <LocalPhoneIcon />, label: "Call Us 24×7", value: "8599005857" },
              { icon: <WhatsAppIcon />, label: "WhatsApp", value: "8599005857" },
              { icon: <EmailIcon />, label: "Email Us", value: "bhubaneshwarcentral.marketing1@mgdealer.co.in" },
            ].map((item, i) => (
              <Grid item xs={12} sm={4} key={i}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, justifyContent: { xs: "center", sm: "flex-start" } }}>
                  <Box sx={{ color: "rgba(255,255,255,0.8)" }}>{item.icon}</Box>
                  <Box>
                    <Typography sx={{ color: "rgba(255,255,255,0.7)", fontSize: "11px", fontFamily: "Roboto, sans-serif" }}>
                      {item.label}
                    </Typography>
                    <Typography sx={{ color: "white", fontSize: { xs: "11px", md: "13px" }, fontWeight: "bold", fontFamily: "Roboto, sans-serif", wordBreak: "break-word" }}>
                      {item.value}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Locations Section */}
        <Box sx={{ py: { xs: 5, md: 8 }, px: { xs: 2, md: 6 }, backgroundColor: "#f7f7f7" }}>
          <Typography
            sx={{
              color: "#D12230",
              fontWeight: "bold",
              fontSize: "12px",
              letterSpacing: "3px",
              textTransform: "uppercase",
              textAlign: "center",
              mb: 1,
              fontFamily: "Roboto, sans-serif",
            }}
          >
            Find Us
          </Typography>
          <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: "bold",
              fontFamily: "Roboto, sans-serif",
              color: "#1a1a1a",
              mb: 5,
              fontSize: { xs: "22px", md: "32px" },
            }}
          >
            Our Showrooms &amp; Service Centres
          </Typography>

          {/* Showrooms */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              fontFamily: "Roboto, sans-serif",
              color: "#D12230",
              mb: 2,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <DirectionsCarIcon /> Showrooms
          </Typography>
          <Grid container spacing={3} sx={{ mb: 5 }}>
            {[LOCATIONS.showroomBhubaneswar, LOCATIONS.showroomCuttack, LOCATIONS.showroomBerhampur, LOCATIONS.showroomJajpur].map((loc, i) => (
              <Grid item xs={12} sm={6} lg={3} key={i}>
                <LocationCard location={loc} />
              </Grid>
            ))}
          </Grid>

          {/* Service Centres */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              fontFamily: "Roboto, sans-serif",
              color: "#1565c0",
              mb: 2,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <BuildIcon /> Service Centres
          </Typography>
          <Grid container spacing={3}>
            {[LOCATIONS.serviceBhubaneswar, LOCATIONS.serviceBerhampur, LOCATIONS.serviceJajpur].map((loc, i) => (
              <Grid item xs={12} sm={6} md={4} key={i}>
                <LocationCard location={loc} />
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Contact Form */}
        <Box sx={{ py: { xs: 5, md: 8 }, px: { xs: 2, md: 6 }, backgroundColor: "#fff" }}>
          <Typography
            sx={{
              color: "#D12230",
              fontWeight: "bold",
              fontSize: "12px",
              letterSpacing: "3px",
              textTransform: "uppercase",
              textAlign: "center",
              mb: 1,
              fontFamily: "Roboto, sans-serif",
            }}
          >
            Get in Touch
          </Typography>
          <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: "bold",
              fontFamily: "Roboto, sans-serif",
              color: "#1a1a1a",
              mb: 5,
              fontSize: { xs: "22px", md: "32px" },
            }}
          >
            Send Us a Message
          </Typography>

          <Container maxWidth="md">
            <Card
              elevation={0}
              sx={{
                border: "1.5px solid #eee",
                borderRadius: "24px",
                p: { xs: 3, md: 5 },
              }}
            >
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="First Name"
                      type="text"
                      variant="outlined"
                      InputLabelProps={{ sx: { "& .MuiInputLabel-asterisk": { color: "#D12230" } } }}
                      value={this.state.firstName}
                      onChange={(e) => this.setState({ firstName: e.target.value })}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", "&.Mui-focused fieldset": { borderColor: "#D12230" } }, "& label.Mui-focused": { color: "#D12230" } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="Last Name"
                      type="text"
                      variant="outlined"
                      InputLabelProps={{ sx: { "& .MuiInputLabel-asterisk": { color: "#D12230" } } }}
                      value={this.state.lastName}
                      onChange={(e) => this.setState({ lastName: e.target.value })}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", "&.Mui-focused fieldset": { borderColor: "#D12230" } }, "& label.Mui-focused": { color: "#D12230" } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="Mobile Number"
                      type="number"
                      variant="outlined"
                      InputLabelProps={{ sx: { "& .MuiInputLabel-asterisk": { color: "#D12230" } } }}
                      value={this.state.mobile}
                      onChange={(e) => this.setState({ mobile: e.target.value })}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", "&.Mui-focused fieldset": { borderColor: "#D12230" } }, "& label.Mui-focused": { color: "#D12230" } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="Email"
                      type="email"
                      variant="outlined"
                      InputLabelProps={{ sx: { "& .MuiInputLabel-asterisk": { color: "#D12230" } } }}
                      value={this.state.email}
                      onChange={(e) => this.setState({ email: e.target.value })}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", "&.Mui-focused fieldset": { borderColor: "#D12230" } }, "& label.Mui-focused": { color: "#D12230" } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required variant="outlined">
                      <InputLabel sx={{ "& .MuiInputLabel-asterisk": { color: "#D12230" } }}>
                        Query Type
                      </InputLabel>
                      <Select
                        label="Query Type"
                        value={this.state.queryType}
                        onChange={(e) => this.setState({ queryType: e.target.value })}
                        sx={{ borderRadius: "10px", "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#D12230" } }}
                      >
                        <MenuItem value="General Inquiry">General Inquiry</MenuItem>
                        <MenuItem value="Technical Support">Technical Support</MenuItem>
                        <MenuItem value="Feedback">Feedback</MenuItem>
                        <MenuItem value="Test Drive">Test Drive</MenuItem>
                        <MenuItem value="Pre-Owned Car">Pre-Owned Car</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="Subject"
                      type="text"
                      variant="outlined"
                      InputLabelProps={{ sx: { "& .MuiInputLabel-asterisk": { color: "#D12230" } } }}
                      value={this.state.querySubject}
                      onChange={(e) => this.setState({ querySubject: e.target.value })}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", "&.Mui-focused fieldset": { borderColor: "#D12230" } }, "& label.Mui-focused": { color: "#D12230" } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Your Message"
                      type="text"
                      variant="outlined"
                      multiline
                      rows={4}
                      value={this.state.query}
                      onChange={(e) => this.setState({ query: e.target.value })}
                      sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px", "&.Mui-focused fieldset": { borderColor: "#D12230" } }, "& label.Mui-focused": { color: "#D12230" } }}
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      checked={this.state.agreedToPolicy}
                      onChange={(e) => this.setState({ agreedToPolicy: e.target.checked })}
                      required
                      sx={{ color: "#D12230", "&.Mui-checked": { color: "#D12230" }, mr: 1 }}
                    />
                    <Typography sx={{ fontFamily: "Gill Sans, sans-serif", fontSize: "14px", color: "#555" }}>
                      I agree to the privacy policy
                      <span style={{ color: "#D12230", marginLeft: "3px" }}>*</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      sx={{
                        backgroundColor: "#D12230",
                        borderRadius: "50px",
                        px: 6,
                        py: 1.5,
                        fontWeight: "bold",
                        fontSize: "15px",
                        fontFamily: "Gill Sans, sans-serif",
                        letterSpacing: "1px",
                        "&:hover": { backgroundColor: "#a81a27" },
                      }}
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Card>
          </Container>
        </Box>

        <Footer />
      </div>
    );
  }
}

export default Contact;
